import React, { CSSProperties } from "react";
import {
  InlineText,
  Paragraph,
  Heading1,
  Heading2,
  Heading3,
  Heading4,
  CTALink,
} from "./styled";
import { TColor } from "../../theme";

export interface TextProps {
  children?: React.ReactNode;
  className?: string;
  isInline?: boolean;
  hasError?: boolean;
  isDisabled?: boolean;
  type?: "mono" | "small" | "caption" | "topic";
  color?: TColor | "currentColor";
  onHoverColor?:
    | "primary"
    | "white"
    | "red"
    | "blue"
    | "secondary"
    | "currentColor"
    | "inherit";
  size?:
    | "inherit"
    | "10px"
    | "12px"
    | "14px"
    | "15px"
    | "16px"
    | "18px"
    | "20px"
    | "22px"
    | "24px"
    | "26px"
    | "28px"
    | "30px"
    | "32px"
    | "36px"
    | "38px"
    | "40px"
    | "42px"
    | "48px"
    | "60px"
    | "80px";
  fontWeight?: CSSProperties["fontWeight"];
  lineHeight?: CSSProperties["lineHeight"];
  decoration?: React.CSSProperties["textDecoration"];
  isBold?: boolean;
  alignText?: string;
  title?: string;
  noMargins?: boolean;
  margin?: React.CSSProperties["margin"];
  maxLines?: number;
  whiteSpace?: CSSProperties["whiteSpace"];
  isUpperCase?: boolean;
  innerHTML?: string;
  id?: string;
  isCapitalized?: boolean;
  fontStyle?: CSSProperties["fontStyle"];
  textWrap?: CSSProperties["textWrap"];
  style?: CSSProperties;
}

const Text: React.FunctionComponent<TextProps> = ({
  className,
  isInline,
  children,
  hasError,
  isDisabled,
  size,
  fontWeight,
  lineHeight,
  decoration,
  isBold,
  whiteSpace = "normal",
  type,
  color = "primary",
  alignText = "inherit",
  title,
  noMargins = false,
  margin,
  maxLines,
  onHoverColor,
  isUpperCase = false,
  innerHTML,
  id,
  isCapitalized,
  fontStyle,
  textWrap,
  style,
}) => {
  const Component = isInline ? InlineText : Paragraph;

  return (
    <Component
      className={className}
      style={style}
      $color={color}
      $isDisabled={isDisabled}
      $type={type}
      $hasError={hasError}
      $size={size}
      $isBold={isBold}
      $fontWeight={fontWeight}
      $lineHeight={lineHeight}
      $decoration={decoration}
      $alignText={alignText}
      $noMargins={noMargins}
      $margin={margin}
      $onHoverColor={onHoverColor ? onHoverColor : color}
      $maxLines={maxLines}
      $whiteSpace={whiteSpace}
      title={title}
      $isUpperCase={isUpperCase}
      $isCapitalized={isCapitalized}
      $fontStyle={fontStyle}
      $textWrap={textWrap}
      id={id}
      {...(innerHTML
        ? {
            dangerouslySetInnerHTML: { __html: innerHTML },
          }
        : null)}
    >
      {!innerHTML ? children : null}
    </Component>
  );
};

export { Heading1, Heading2, Heading3, Heading4, CTALink };
export default Text;
